var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c("div", { attrs: { slot: "header" }, slot: "header" }, [
        _c("div", [_vm._v(_vm._s(_vm.title))]),
        _c("div", { class: _vm.$style.titleDescription }, [
          _vm._v(
            "Drag image here or upload manually, and use our cropper to adjust the position and size."
          ),
        ]),
      ]),
      _c(
        "div",
        { class: _vm.$style.vModalBody, attrs: { slot: "body" }, slot: "body" },
        [
          _c("rb-input-file", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: { required: true },
                expression: "{required: true}",
              },
            ],
            attrs: {
              name: "profile_picture",
              "data-vv-as": "Profile Picture",
              "vv-error": _vm.$showError("profile_picture"),
              reset: _vm.reset,
              "croppie-options": _vm.croppieOptions,
            },
            model: {
              value: _vm.picture,
              callback: function ($$v) {
                _vm.picture = $$v
              },
              expression: "picture",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          class: _vm.$style.vModalFooter,
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.picture
            ? _c(
                "button",
                {
                  staticClass: "rbButton",
                  class: _vm.$style.resetButton,
                  attrs: { type: "reset" },
                  on: {
                    click: function ($event) {
                      _vm.reset = !_vm.reset
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("cloud_upload"),
                  ]),
                  _vm._v(" Upload Different Image "),
                ]
              )
            : _vm._e(),
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _vm.picture
            ? _c(
                "button",
                {
                  staticClass: "rbButton mainButton",
                  attrs: { type: "submit" },
                },
                [_vm._v(" Save")]
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }